module.exports = __webpack_public_path__ + "img/dog_megaphone.9f5e6274.png";